var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "div",
        { attrs: { id: "tab-mbl2" } },
        [
          _c("div", { staticClass: "section operations" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.cooperateEdit,
                    expression: "cooperateEdit"
                  }
                ],
                staticClass: "triggers"
              },
              [
                _c(
                  "div",
                  [
                    _c(
                      "el-dropdown",
                      {
                        class: _vm.readonly ? "not-click" : "",
                        staticStyle: { "margin-right": "5px" },
                        attrs: { no: "1", "split-button": "", type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.commandHandle(_vm.command1)
                          },
                          command: function(p) {
                            _vm.command1 = p
                            _vm.commandHandle(_vm.command1)
                          }
                        }
                      },
                      [
                        _vm._v(" " + _vm._s(_vm.command1) + " "),
                        _c(
                          "el-dropdown-menu",
                          { attrs: { slot: "dropdown" }, slot: "dropdown" },
                          [
                            _c(
                              "el-dropdown-item",
                              {
                                attrs: {
                                  command: _vm.$t("SeaExport.CodeSearching")
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.CodeSearching"))
                                )
                              ]
                            ),
                            _c(
                              "el-dropdown-item",
                              {
                                attrs: {
                                  command: _vm.$t(
                                    "SeaExport.CopyFromTheLastTime"
                                  )
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("SeaExport.CopyFromTheLastTime")
                                  )
                                )
                              ]
                            ),
                            _c(
                              "el-dropdown-item",
                              {
                                attrs: {
                                  command: _vm.$t("SeaExport.CopyFromOtherBill")
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.CopyFromOtherBill"))
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-checkbox",
                      {
                        attrs: { no: "2", disabled: _vm.readonly },
                        model: {
                          value: _vm.form.edi,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "edi", $$v)
                          },
                          expression: "form.edi"
                        }
                      },
                      [_vm._v("EDI")]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        staticStyle: { "margin-left": "-20px" },
                        attrs: { no: "3", disabled: _vm.readonly },
                        model: {
                          value: _vm.form.oversea,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "oversea", $$v)
                          },
                          expression: "form.oversea"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.BlBeReleased")))]
                    )
                  ],
                  1
                )
              ]
            )
          ]),
          _c("div", { staticStyle: { display: "flex" } }, [
            _c(
              "div",
              { staticClass: "section form-column" },
              [
                _c(
                  "el-form",
                  {
                    staticStyle: { height: "100%" },
                    attrs: { "label-width": "70px", "label-position": "right" }
                  },
                  [
                    _c("span", { staticClass: "title" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("SeaExport.ConsigneeShipperAndNotifyInfo")
                        )
                      )
                    ]),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "custom",
                        attrs: { label: _vm.$t("Message.Shipper") }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-input", {
                              staticStyle: { flex: "1" },
                              attrs: { disabled: _vm.readonly, no: "4" },
                              model: {
                                value: _vm.form.shipperCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "shipperCode", $$v)
                                },
                                expression: "form.shipperCode"
                              }
                            }),
                            _c(
                              "el-button",
                              {
                                staticStyle: { "margin-left": "5px" },
                                attrs: {
                                  no: "5",
                                  disabled: _vm.readonly,
                                  type: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.clearSenderAndReceiver(
                                      "shipper",
                                      7
                                    )
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Reset")))]
                            )
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._l(7, function(count) {
                      return _c(
                        "el-form-item",
                        {
                          key: "shipperLine" + count,
                          class:
                            "custom " +
                            _vm.getSenderAndReceiverColor("shipperLine", count)
                        },
                        [
                          _c("cargo-input", {
                            ref: "shipperLine" + count,
                            refInFor: true,
                            attrs: {
                              disabled: _vm.readonly,
                              no: "shipperLine" + count,
                              "auto-uppercase":
                                _vm.notUppercaseShipperConsigneNotify,
                              "use-read-only": true
                            },
                            on: {
                              change: function() {
                                return _vm.wrapAddr(
                                  _vm.form,
                                  "shipperLine" + count,
                                  count + 1 > 7
                                    ? null
                                    : "shipperLine" + (count + 1),
                                  _vm.maxChars
                                )
                              }
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                return _vm.showSenderAndReceiverDialog(
                                  "shipper",
                                  7,
                                  false,
                                  _vm.notUppercaseShipperConsigneNotify
                                )
                              }
                            },
                            model: {
                              value: _vm.form["shipperLine" + count],
                              callback: function($$v) {
                                _vm.$set(_vm.form, "shipperLine" + count, $$v)
                              },
                              expression: "form['shipperLine'+count]"
                            }
                          })
                        ],
                        1
                      )
                    }),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "custom",
                        attrs: { label: _vm.$t("Message.Consignee") }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-input", {
                              staticStyle: { flex: "1" },
                              attrs: { disabled: _vm.readonly, no: "6" },
                              model: {
                                value: _vm.form.consigneeCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "consigneeCode", $$v)
                                },
                                expression: "form.consigneeCode"
                              }
                            }),
                            _c(
                              "el-button",
                              {
                                staticStyle: { "margin-left": "5px" },
                                attrs: {
                                  no: "7",
                                  type: "primary",
                                  disabled: _vm.readonly
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.clearSenderAndReceiver(
                                      "consignee",
                                      7
                                    )
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Reset")))]
                            )
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._l(7, function(count) {
                      return _c(
                        "el-form-item",
                        {
                          key: "consigneeLine" + count,
                          class:
                            "custom " +
                            _vm.getSenderAndReceiverColor(
                              "consigneeLine",
                              count
                            )
                        },
                        [
                          _c("cargo-input", {
                            ref: "consigneeLine" + count,
                            refInFor: true,
                            attrs: {
                              disabled: _vm.readonly,
                              no: "consigneeLine" + count,
                              "auto-uppercase":
                                _vm.notUppercaseShipperConsigneNotify,
                              "use-read-only": true
                            },
                            on: {
                              change: function() {
                                return _vm.wrapAddr(
                                  _vm.form,
                                  "consigneeLine" + count,
                                  count + 1 > 7
                                    ? null
                                    : "consigneeLine" + (count + 1),
                                  _vm.maxChars
                                )
                              }
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                return _vm.showSenderAndReceiverDialog(
                                  "consignee",
                                  7,
                                  false,
                                  _vm.notUppercaseShipperConsigneNotify
                                )
                              }
                            },
                            model: {
                              value: _vm.form["consigneeLine" + count],
                              callback: function($$v) {
                                _vm.$set(_vm.form, "consigneeLine" + count, $$v)
                              },
                              expression: "form['consigneeLine'+count]"
                            }
                          })
                        ],
                        1
                      )
                    }),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "custom",
                        attrs: { label: _vm.$t("Message.Notify") }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-input", {
                              staticStyle: { flex: "1", width: "100px" },
                              attrs: { disabled: _vm.readonly, no: "8" },
                              model: {
                                value: _vm.form.notifyCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "notifyCode", $$v)
                                },
                                expression: "form.notifyCode"
                              }
                            }),
                            _c(
                              "el-button",
                              {
                                staticStyle: { "margin-left": "5px" },
                                attrs: {
                                  no: "9",
                                  disabled: _vm.readonly,
                                  type: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.clearSenderAndReceiver(
                                      "notify",
                                      7
                                    )
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Reset")))]
                            ),
                            _c(
                              "el-button",
                              {
                                staticStyle: { "margin-left": "5px" },
                                attrs: {
                                  no: "10",
                                  disabled: _vm.readonly,
                                  type: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.pm.onCopyConsignee()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.CopyTheConsignee"))
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._l(7, function(count) {
                      return _c(
                        "el-form-item",
                        {
                          key: "notifyLine" + count,
                          class:
                            "custom " +
                            _vm.getSenderAndReceiverColor("notifyLine", count)
                        },
                        [
                          _c("cargo-input", {
                            ref: "notifyLine" + count,
                            refInFor: true,
                            attrs: {
                              disabled: _vm.readonly,
                              no: "notifyLine" + count,
                              "auto-uppercase":
                                _vm.notUppercaseShipperConsigneNotify,
                              "use-read-only": true
                            },
                            on: {
                              change: function() {
                                return _vm.wrapAddr(
                                  _vm.form,
                                  "notifyLine" + count,
                                  count + 1 > 7
                                    ? null
                                    : "notifyLine" + (count + 1),
                                  _vm.maxChars
                                )
                              }
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                return _vm.showSenderAndReceiverDialog(
                                  "notify",
                                  7,
                                  false,
                                  _vm.notUppercaseShipperConsigneNotify
                                )
                              }
                            },
                            model: {
                              value: _vm.form["notifyLine" + count],
                              callback: function($$v) {
                                _vm.$set(_vm.form, "notifyLine" + count, $$v)
                              },
                              expression: "form['notifyLine'+count]"
                            }
                          })
                        ],
                        1
                      )
                    }),
                    _c(
                      "el-form-item",
                      { staticClass: "custom", attrs: { "label-width": "0" } },
                      [
                        _c("span", { staticStyle: { color: "#404144" } }, [
                          _vm._v("ALSO NOTIFY")
                        ])
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { staticClass: "custom" },
                      [
                        _c("cargo-rich-textarea", {
                          staticStyle: { height: "110px" },
                          attrs: {
                            no: "11",
                            disabled: !_vm.isEdit,
                            "text-chars": _vm.maxChars,
                            "warning-count": _vm.warningCount
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                "ALSO NOTIFY",
                                _vm.form.alsoNotify,
                                function(val) {
                                  _vm.form.alsoNotify = val.toUpperCase()
                                },
                                false,
                                null,
                                _vm.notUppercaseShipperConsigneNotify
                              )
                            }
                          },
                          model: {
                            value: _vm.form.alsoNotify,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "alsoNotify", $$v)
                            },
                            expression: "form.alsoNotify"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  2
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "section form-column" },
              [
                _c(
                  "el-form",
                  {
                    staticStyle: { height: "100%" },
                    attrs: {
                      disabled: _vm.readonly,
                      "label-width": "85px",
                      "label-position": "right"
                    }
                  },
                  [
                    _c("span", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.$t("SeaExport.CargoInfo")))
                    ]),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.NumberOfPackagesOnBl")
                        }
                      },
                      [
                        _c("auto-number-input", {
                          attrs: { no: "12", precision: 0, min: 0 },
                          on: {
                            change: function($event) {
                              return _vm.pm.quantity_Change(_vm.form.quantity)
                            }
                          },
                          model: {
                            value: _vm.form.quantity,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "quantity", $$v)
                            },
                            expression: "form.quantity"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: _vm.variableCss.packing,
                        attrs: { label: _vm.$t("SeaExport.Package") }
                      },
                      [
                        _c("cargo-packing-select", {
                          attrs: {
                            no: "13",
                            "default-value": _vm.form.packing
                          },
                          on: {
                            change: function(p) {
                              _vm.pm.packing_Change(p)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: _vm.variableCss.insideQuantity,
                        attrs: { label: _vm.$t("SeaExport.Pieces2") }
                      },
                      [
                        _c("auto-number-input", {
                          attrs: { no: "14", precision: 0, min: 0 },
                          model: {
                            value: _vm.form.insideQuantity,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "insideQuantity", $$v)
                            },
                            expression: "form.insideQuantity"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: _vm.variableCss.insidePacking,
                        attrs: { label: _vm.$t("SeaExport.PiecesType2") }
                      },
                      [
                        _c("cargo-packing-select", {
                          attrs: {
                            no: "15",
                            "default-value": _vm.form.insidePacking
                          },
                          on: {
                            change: function(p) {
                              _vm.form.insidePacking = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: "custom " + _vm.variableCss.weight,
                        attrs: { label: _vm.$t("SeaExport.GrossWeight") }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "form-item-input",
                            class: _vm.readonly ? "input-disabled" : ""
                          },
                          [
                            _c("auto-number-input", {
                              attrs: { no: "16", precision: 3, min: 0 },
                              model: {
                                value: _vm.form.weight,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "weight", $$v)
                                },
                                expression: "form.weight"
                              }
                            }),
                            _c("span", [_vm._v("KGS")])
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: "custom " + _vm.variableCss.cubage,
                        attrs: { label: _vm.$t("SeaExport.Cubage") }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "form-item-input",
                            class: _vm.readonly ? "input-disabled" : ""
                          },
                          [
                            _c("auto-number-input", {
                              attrs: { no: "17", precision: 3, min: 0 },
                              model: {
                                value: _vm.form.cubage,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "cubage", $$v)
                                },
                                expression: "form.cubage"
                              }
                            }),
                            _c("span", [_vm._v("CBM")])
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "custom",
                        attrs: { label: _vm.$t("SeaExport.ChargedWeightRT") }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "form-item-input",
                            class: _vm.readonly ? "input-disabled" : ""
                          },
                          [
                            _c("auto-number-input", {
                              attrs: { no: "18", precision: 3, min: 0 },
                              model: {
                                value: _vm.form.chargeWeight,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "chargeWeight", $$v)
                                },
                                expression: "form.chargeWeight"
                              }
                            }),
                            _c("span", [_vm._v("M/T")])
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        class:
                          "label-none custom " +
                          _vm.variableCss.cargoEnglishName,
                        attrs: {
                          label: _vm.$t("queryJob.englishDescriptionOfGoods")
                        }
                      },
                      [
                        _c("cargo-rich-textarea", {
                          staticStyle: { height: "110px" },
                          attrs: {
                            no: "19",
                            disabled: !_vm.isEdit,
                            "text-chars": 0,
                            "auto-uppercase": _vm.isUppercaseByConfig
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("queryJob.englishDescriptionOfGoods"),
                                _vm.form.cargoEnglishName,
                                function(val) {
                                  _vm.form.cargoEnglishName = val
                                },
                                false,
                                null,
                                _vm.isUppercaseByConfig,
                                {
                                  warningCount: _vm.englishNameWarningCount,
                                  maxChar: _vm.englishNameMaxChars
                                }
                              )
                            }
                          },
                          model: {
                            value: _vm.form.cargoEnglishName,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "cargoEnglishName", $$v)
                            },
                            expression: "form.cargoEnglishName"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: "label-none custom " + _vm.variableCss.mark,
                        attrs: { label: _vm.$t("SeaExport.Marks") }
                      },
                      [
                        _c("cargo-rich-textarea", {
                          staticStyle: { height: "110px" },
                          attrs: {
                            no: "20",
                            disabled: !_vm.isEdit,
                            "text-chars": 0,
                            "warning-count": 22,
                            "auto-uppercase": _vm.isUppercaseByConfig
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.Marks"),
                                _vm.form.mark,
                                function(val) {
                                  _vm.form.mark = val
                                },
                                false,
                                null,
                                _vm.isUppercaseByConfig,
                                {
                                  warningCount: _vm.markWarningCount,
                                  maxChar: _vm.markMaxChars
                                }
                              )
                            }
                          },
                          model: {
                            value: _vm.form.mark,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "mark", $$v)
                            },
                            expression: "form.mark"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "label-none custom",
                        attrs: {
                          label: _vm.$t(
                            "SeaExport.CapitalizedNumbersOfPackages"
                          )
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "21", disabled: true },
                          model: {
                            value: _vm.form.quantitySum,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "quantitySum", $$v)
                            },
                            expression: "form.quantitySum"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "section form-column" },
              [
                _c(
                  "el-form",
                  {
                    staticStyle: { height: "100%" },
                    attrs: {
                      disabled: _vm.readonly,
                      "label-width": "85px",
                      "label-position": "right"
                    }
                  },
                  [
                    _c("span", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.$t("SeaExport.TransportInfo")))
                    ]),
                    _c(
                      "el-form-item",
                      { attrs: { label: "MB/L NO2." } },
                      [
                        _c("el-input", {
                          attrs: { no: "22" },
                          model: {
                            value: _vm.form.mblNbr2,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "mblNbr2", $$v)
                            },
                            expression: "form.mblNbr2"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "HB/L NO2." } },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "23",
                            disabled: true,
                            value: _vm.form.hblNbr2
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Payment.vesselAndVoyage") } },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "24",
                            disabled: true,
                            value: _vm.txtFirstVesselVoyage
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("queryJob.dateOfDeparture") } },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "25",
                            disabled: true,
                            value: _vm.moment(_vm.job.etd).format("YYYY-MM-DD")
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: _vm.variableCss.dispatchingPlace,
                        attrs: {
                          label: _vm.$t("SeaExport.DocDispatchingPlace")
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "26" },
                          model: {
                            value: _vm.form.dispatchingPlace,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "dispatchingPlace", $$v)
                            },
                            expression: "form.dispatchingPlace"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: _vm.variableCss.loadingPort,
                        attrs: { label: _vm.$t("SeaExport.PortOfLoadingOnBl") }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "27" },
                          model: {
                            value: _vm.form.loadingPort,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "loadingPort", $$v)
                            },
                            expression: "form.loadingPort"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: _vm.variableCss.dischargingPort,
                        attrs: {
                          label: _vm.$t("SeaExport.PortOfDischargeOnBl")
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "28" },
                          model: {
                            value: _vm.form.dischargingPort,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "dischargingPort", $$v)
                            },
                            expression: "form.dischargingPort"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: _vm.variableCss.destinationPort,
                        attrs: {
                          label: _vm.$t("SeaExport.PlaceOfDeliveryOnBl")
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "29" },
                          model: {
                            value: _vm.form.destinationPort,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "destinationPort", $$v)
                            },
                            expression: "form.destinationPort"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("SeaExport.MethodOfMblPayment") }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "30",
                            value: _vm.ColumnUtils.paymentTermLabelFunc(
                              _vm.form.paymentTerm
                            )
                          },
                          on: {
                            input: function(val) {
                              _vm.form.paymentTerm = val
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("SeaExport.PlaceOfMblPayment2") }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "31",
                            disabled: true,
                            value: _vm.form.paymentPlaceBL
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.TransportationClause")
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "32",
                            disabled: true,
                            value: _vm.job.freightTermMBL
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: _vm.variableCss.blNumber,
                        attrs: { label: _vm.$t("SeaExport.NoOfOriginalBls") }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "33" },
                          model: {
                            value: _vm.form.blNumber,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "blNumber", $$v)
                            },
                            expression: "form.blNumber"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.PlaceOfIssue") } },
                      [
                        _c("el-input", {
                          attrs: { no: "34" },
                          model: {
                            value: _vm.form.signPlaceBL,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "signPlaceBL", $$v)
                            },
                            expression: "form.signPlaceBL"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.DateOfIssue") } },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            no: "35",
                            type: "date",
                            "value-format": "yyyy-MM-dd"
                          },
                          model: {
                            value: _vm.form.signDateBL,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "signDateBL", $$v)
                            },
                            expression: "form.signDateBL"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: _vm.variableCss.remarks,
                        attrs: { label: _vm.$t("SeaExport.BlRemarks") }
                      },
                      [
                        _c("cargo-rich-textarea", {
                          staticStyle: { height: "110px" },
                          attrs: {
                            no: "36",
                            disabled: !_vm.isEdit,
                            "text-chars": _vm.maxChars,
                            "warning-count": _vm.warningCount
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.BlRemarks"),
                                _vm.form.remarks,
                                function(val) {
                                  _vm.form.remarks = val
                                }
                              )
                            }
                          },
                          model: {
                            value: _vm.form.remarks,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "remarks", $$v)
                            },
                            expression: "form.remarks"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "section form-column" },
              [
                _c(
                  "el-form",
                  {
                    staticStyle: { height: "100%" },
                    attrs: {
                      disabled: _vm.readonly,
                      "label-width": "100px",
                      "label-position": "right"
                    }
                  },
                  [
                    _c("span", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.$t("SeaExport.OtherInfo")))
                    ]),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.job.typeMBL ===
                              _vm.BillType.SPLIT_BILL_TYPE.code,
                            expression:
                              "job.typeMBL===BillType.SPLIT_BILL_TYPE.code"
                          }
                        ],
                        staticClass: "auto-width",
                        attrs: { "label-width": "0" }
                      },
                      [
                        _c("cargo-ag-grid", {
                          staticStyle: { width: "100%", height: "200px" },
                          attrs: {
                            no: "37",
                            "grid-options": _vm.splitOrder.gridOptions,
                            "grid-params": _vm.splitOrder.gridParams,
                            "column-defs": _vm.splitOrder.columnDefs,
                            "row-data": _vm.splitOrderFinalRowData,
                            "show-side-bar": false
                          },
                          on: {
                            "update:gridParams": function($event) {
                              return _vm.$set(
                                _vm.splitOrder,
                                "gridParams",
                                $event
                              )
                            },
                            "update:grid-params": function($event) {
                              return _vm.$set(
                                _vm.splitOrder,
                                "gridParams",
                                $event
                              )
                            },
                            gridReady: function(params) {
                              _vm.splitOrder.gridApi = params.api
                            }
                          }
                        }),
                        _c("div", { staticStyle: { padding: "5px 0" } }, [
                          _c(
                            "div",
                            { staticStyle: { float: "right" } },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { no: "38", type: "primary" },
                                  on: {
                                    click: function($event) {
                                      return _vm.pm.onAddSplitDocEvent()
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("Payment.new")))]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { no: "39", type: "danger" },
                                  on: {
                                    click: function($event) {
                                      return _vm.pm.onRemoveSliptDocEvent()
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("FileHistory.Delete")))]
                              )
                            ],
                            1
                          )
                        ])
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.job.typeMBL ===
                              _vm.BillType.MERGE_BILL_TYPE.code,
                            expression:
                              "job.typeMBL===BillType.MERGE_BILL_TYPE.code"
                          }
                        ],
                        staticClass: "auto-width",
                        attrs: { "label-width": "0" }
                      },
                      [
                        _c("cargo-ag-grid", {
                          staticStyle: { width: "100%", height: "200px" },
                          attrs: {
                            no: "40",
                            "grid-options": _vm.mergeOrder.gridOptions,
                            "grid-params": _vm.mergeOrder.gridParams,
                            "column-defs": _vm.mergeOrder.columnDefs,
                            "row-data": _vm.mergeOrderFinalRowData,
                            "show-side-bar": false
                          },
                          on: {
                            "update:gridParams": function($event) {
                              return _vm.$set(
                                _vm.mergeOrder,
                                "gridParams",
                                $event
                              )
                            },
                            "update:grid-params": function($event) {
                              return _vm.$set(
                                _vm.mergeOrder,
                                "gridParams",
                                $event
                              )
                            },
                            gridReady: function(params) {
                              _vm.mergeOrder.gridApi = params.api
                            }
                          }
                        }),
                        _c("div", { staticStyle: { padding: "5px 0" } }, [
                          _c(
                            "div",
                            { staticStyle: { float: "right" } },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { no: "41", type: "primary" },
                                  on: {
                                    click: function($event) {
                                      return _vm.pm.onJobsAdd()
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.Add3")))]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { no: "42", type: "danger" },
                                  on: {
                                    click: function($event) {
                                      return _vm.pm.onJobsRemove()
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("FileHistory.Delete")))]
                              )
                            ],
                            1
                          )
                        ])
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.BlType") } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              no: "43",
                              value: _vm.form.releaseType || ""
                            },
                            on: {
                              input: function(val) {
                                _vm.form.releaseType = val
                              },
                              change: function(val) {
                                _vm.pm.cmbreleaseTypeMBLChangeHandler(val)
                              }
                            }
                          },
                          _vm._l(_vm.blModeList, function(item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label: item.name,
                                value: item.serialNumber
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "SeaExport.BillingOfLadingRecordManager"
                          )
                        }
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass:
                              "el-button el-button--primary el-button--mini",
                            class: _vm.isEdit ? "is-disabled" : "",
                            staticStyle: {
                              display: "inline-block",
                              width: "100%",
                              "text-align": "center"
                            },
                            on: {
                              click: function($event) {
                                _vm.isEdit
                                  ? ""
                                  : (_vm.statusChangeHistoryDialog.visible = true)
                              }
                            }
                          },
                          [_vm._v("……")]
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "red",
                        attrs: { label: _vm.$t("SeaExport.ReleasingStatus") }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "44",
                            disabled: true,
                            value: _vm.lblReleaseState
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.preverifyDate") } },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            no: "47",
                            disabled: true,
                            type: "date",
                            "value-format": "yyyy-MM-dd"
                          },
                          model: {
                            value: _vm.form.reviewDate,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "reviewDate", $$v)
                            },
                            expression: "form.reviewDate"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.ReleasingDate") } },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            no: "48",
                            disabled: true,
                            type: "date",
                            "value-format": "yyyy-MM-dd"
                          },
                          model: {
                            value: _vm.form.releaseDate,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "releaseDate", $$v)
                            },
                            expression: "form.releaseDate"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.DateOfCargoDetention")
                        }
                      },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            no: "49",
                            disabled: true,
                            type: "date",
                            "value-format": "yyyy-MM-dd"
                          },
                          model: {
                            value: _vm.form.withholdDate,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "withholdDate", $$v)
                            },
                            expression: "form.withholdDate"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.ShippingCompanySCAC")
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "50",
                            disabled: true,
                            value: _vm.job.carrierScac || _vm.txtCarrierScAc
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("SeaExport.OverseasAgentSCAC") }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "51",
                            disabled: true,
                            value: _vm.txtBookingAgentScAc
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.ContainerAmount") } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "100%" },
                          attrs: { no: "52", type: "textarea", rows: 5 },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.ContainerAmount"),
                                _vm.form.seaeq,
                                function(val) {
                                  _vm.form.seaeq = val
                                }
                              )
                            }
                          },
                          model: {
                            value: _vm.form.seaeq,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "seaeq", $$v)
                            },
                            expression: "form.seaeq"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.CNTRNOSSEALNOS") } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "100%" },
                          attrs: { no: "53", type: "textarea", rows: 5 },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.CNTRNOSSEALNOS"),
                                _vm.form.container,
                                function(val) {
                                  _vm.form.container = val
                                }
                              )
                            }
                          },
                          model: {
                            value: _vm.form.container,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "container", $$v)
                            },
                            expression: "form.container"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.ReasonOfCargoDetention")
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "54",
                            disabled: true,
                            value: _vm.form.withholdReason,
                            type: "textarea",
                            rows: 5
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.advanceTextDialog.visible,
                title: _vm.advanceTextDialog.title,
                width: "600px",
                "close-on-click-modal": false,
                "close-on-press-escape": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.advanceTextDialog, "visible", $event)
                }
              }
            },
            [
              _c("cargo-rich-textarea", {
                staticStyle: { height: "320px" },
                attrs: {
                  "text-chars": _vm.advanceTextDialog.formatObj.maxChar,
                  "auto-uppercase": _vm.advanceTextDialog.isUppercase,
                  "warning-count": _vm.advanceTextDialog.formatObj.warningCount,
                  disabled: !_vm.isEdit
                },
                model: {
                  value: _vm.advanceTextDialog.value,
                  callback: function($$v) {
                    _vm.$set(_vm.advanceTextDialog, "value", $$v)
                  },
                  expression: "advanceTextDialog.value"
                }
              }),
              _c(
                "span",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isEdit,
                          expression: "isEdit"
                        }
                      ],
                      attrs: { no: "55", type: "primary" },
                      on: { click: _vm.finishAdvanceText }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "56" },
                      on: {
                        click: function($event) {
                          _vm.advanceTextDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("bill-address-dialog", {
            attrs: { visible: _vm.billAddressDialog.visible, job: _vm.job },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.billAddressDialog, "visible", $event)
              },
              callback: _vm.codeSearchCallback
            }
          }),
          _vm.searchBillNoDialog.visible
            ? _c("job-no-transcribe-dialog", {
                attrs: {
                  visible: _vm.searchBillNoDialog.visible,
                  lob: "SI",
                  params: _vm.searchBillNoDialog.params
                },
                on: {
                  "update:visible": function($event) {
                    return _vm.$set(_vm.searchBillNoDialog, "visible", $event)
                  },
                  selected: _vm.searchBillNoDialog.selectHandler
                }
              })
            : _vm._e(),
          _c("status-change-history-dialog", {
            attrs: {
              visible: _vm.statusChangeHistoryDialog.visible,
              "business-data-id": _vm.form.uuid
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(
                  _vm.statusChangeHistoryDialog,
                  "visible",
                  $event
                )
              }
            }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }